<template>
  <div class="layout-component">
    <div class="sections" v-if="scoresReady">
      <div
        :class="['section', section.cssClass]"
        v-for="(section, i) in visibleSections"
        :key="section.key"
      >
        <div class="layout-rows">
          <div
            :id="`row-container-${row.id}`"
            :key="`${keyBase}-row-container-${row.id}`"
            :class="['layout-row-container', row.cssClass]"
            v-for="(row, j) in visibleRows(section.rows)"
          >
            <LayoutRow
              :translation-context="
                `options.layout.sections.${section.key}.rows.${row.id}`
              "
              :show-overlay="false"
              :key="`${keyBase}-row-${row.id}`"
              ref="rows"
              :class="[
                'row',
                `columns-count-${row.columns.length}`,
                `row-${row.class}`
              ]"
              :id="row.id"
              :row="row"
            ></LayoutRow>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import Utilities from "../../lib/Utilities.js";
import Helpers from "../../lib/Helpers";
import LayoutRow from "./LayoutRow.vue";
import Block from "./Block.vue";
import ScoreDebug from "./ScoreDebug.vue";
import DisplayConditionsMixin from "../../lib/DisplayConditionsMixin";
import _ from "lodash";
export default {
  props: {
    config: { type: Object, default: () => {} },
    editable: { type: Boolean, default: false }
  },
  inject: ["convince"],
  provide() {
    return {
      resultData: this.resultData
    };
  },
  mixins: [DisplayConditionsMixin],
  helpers: [Helpers],
  components: {
    LayoutRow,
    Block,
    ScoreDebug
  },
  data() {
    return {
      content: {},
      scoresReady: false,
      resultData: {}
    };
  },
  computed: {
    keyBase() {
      return this.$vnode.key;
    },
    visibleSections() {
      return this.content.options.layout.sections.filter((section) => {
        return this.meetsDisplayConditions(section.display);
      });
    }
  },
  created() {
    this.content = JSON.parse(JSON.stringify(this.config));

    this.getData();
  },
  mounted() {},
  methods: {
    visibleRows(rows) {
      return rows.filter((row) => {
        return this.meetsDisplayConditions(row.display);
      });
    },
    async getData() {
      if (!this.$route.name === "result") {
        await this.$store.dispatch("start");
      }
      await this.$store.dispatch("finalise");

      const [scoreResponse, agreementResponse] = await Promise.all([
        this.$store.dispatch("getScores"),
        this.convince.result()
      ]);
      this.$set(this.resultData, "scores", scoreResponse);
      for (const prop in agreementResponse.data) {
        this.$set(this.resultData, prop, agreementResponse.data[prop]);
      }
      this.$store.commit("setResult", this.resultData);
      this.scoresReady = true;
      this.$emit("ready");
    },
    getScores() {
      this.$store.dispatch("getScores").then((result) => {
        this.scoresReady = true;
      });
    },
    getRowWithKey(key) {
      const rows = this.content.options.layout.rows;
      for (let i = 0; i < rows.length; i++) {
        let rowComponent = this.$refs.rows[i];
        let row = rows[i];
        if (row.key === key) {
          return { row: row, index: i, component: rowComponent };
        }
      }
      return null;
    }
  }
};
</script>
<style lang="scss" scoped>
.layout-row-container {
  position: relative;
}
.layout-placeholder {
  min-height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  a.button {
    background-color: white;
    border: 1px solid #dedede;
    color: #ccc;
  }
}
.row-actions {
  text-align: center;
  background-color: #efefef;
  padding: 3px 0;
  &:hover {
    a.menu-button {
      opacity: 1;
      span.label {
        display: inline;
      }
    }
  }
}
</style>
